import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { accessToken, sessionExpired } = useSelector((state) => state.auth);
  const companyStatus = useSelector(
    (state) => state.auth.stagingStageStatu?.companyStatus
  );
  const userRole = useSelector((state) => state.auth.user?.roles?.[0]);
  const location = useLocation();

  const localToken = localStorage.getItem("accessToken");

  if (!accessToken && !localToken && !sessionExpired) {
    return <Navigate to="/" replace />;
  }

  const isCompanyAdmin =
    userRole === "COMPANY_ADMIN" || userRole === "COMPANY_SUPER_ADMIN";

  // Approved company admins can only access /hospitalManagement among protected routes
  if (
    isCompanyAdmin &&
    companyStatus === "APPROVED" &&
    !location.pathname.startsWith("/hospitalManagement") &&
    !location.pathname.startsWith("/viewCandidate")
  ) {
    return <Navigate to="/hospitalManagement" replace />;
  }

  // Non-approved company admins cannot access /hospitalManagement or /viewCandidate
  if (
    isCompanyAdmin &&
    companyStatus !== "APPROVED" &&
    (location.pathname.startsWith("/hospitalManagement") ||
      location.pathname.startsWith("/viewCandidate"))
  ) {
    return <Navigate to="/employeeFlow/BasicInfo" replace />;
  }

  return children;
};

export default ProtectedRoute;
